module.exports = __webpack_public_path__ + "img/order9.95fb7e3a.svg";